// extracted by mini-css-extract-plugin
module.exports = {"section":"Calculator_section__IgjVS"};